import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ENV } from 'utils/env';
import ApplePayForm from './ApplePayForm';

const stripePromise = loadStripe(ENV.STRIPE_PUBLIC_KEY);

const ApplePay: React.FunctionComponent = () => {
    return (
        <Elements stripe={stripePromise}>
            <ApplePayForm />
        </Elements>
    );
};

export default ApplePay;
